import { createFileRoute } from '@tanstack/react-router';
import { FinanceSettingsScreen } from '../../screens/finance/Settings';

export const Route = createFileRoute('/finance/settings')({
  component: FinanceSettingsScreen,
});
